// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.blueBtn[data-v-c7272d46] {\n  font-size: 11px;\n  color: rgb(64, 158, 255);\n  margin: 0 2px;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
